import { render } from "./px-switch.vue?vue&type=template&id=cba45ea8&scoped=true&ts=true"
import script from "./px-switch.vue?vue&type=script&lang=ts"
export * from "./px-switch.vue?vue&type=script&lang=ts"

import "./px-switch.vue?vue&type=style&index=0&id=cba45ea8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cba45ea8"]])

export default __exports__